module.exports = __webpack_public_path__ + "static/proweek-panel-c9e05a3b56c700e73a34b7d16929f4c3.png";